export const muiStepLabelTheme = {
  MuiStepLabel: {
    styleOverrides: {
      label: {
        '&.MuiStepLabel-alternativeLabel': {
          marginTop: 8,
        },
      },
    },
  },
};
